<template>
  <el-table ref="table" v-on="$listeners" class="list" :data="customPrioritiesList">
    <el-table-column prop="id_transaction" label="ID транзакции" align="center" />
    <el-table-column prop="type" label="Тип транзакции" align="center" />
    <el-table-column prop="criteria_value" label="Критерий" align="center" />
    <el-table-column prop="priority" label="Приоритет" align="center" />
    <el-table-column prop="editor_login" label="Пользователь" align="center" />
    <el-table-column prop="created_at" label="Дата транзакции" align="center" />
    <el-table-column label="Действия" align="center" >
      <template slot-scope="scope">
        <el-button
          size="mini"
          type="danger"
          icon="el-icon-delete"
          :loading="isDeletingTransaction"
          @click="removeTransaction(scope.row)"
        >
          Откатить изменения
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import { priorityTypes, priorityTypesText } from "@/components/Priorities/consts";

  export default {
    name: "PrioritiesTable",
    props: {
      priorities: {
        type: Array,
        default: () => [],
      },
      isDeletingTransaction: {
        type: Boolean,
        default: false,
      },
      removeTransaction: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        priorityTypes,
        priorityTypesText,
      };
    },
    computed: {
      customPrioritiesList() {
        return this.priorities.map((priority) => {
          const oPriority = Object.assign({}, priority);
          oPriority.type = priorityTypesText[priority.type];

          return oPriority;
        })
      },
    },
  };
</script>
